import { useQuery } from "react-query";

import { adjustmentsService } from "services";

type UseAdjustmentsListProps = {
	paidMonth: string;
	paidYear: string;
	fetchData: {
		page: number;
		filters: any;
		sortBy: { id: string; desc: boolean };
	};
};

const useAdjustmentsListQuery = ({
	fetchData,
	paidMonth,
	paidYear,
}: UseAdjustmentsListProps) => {
	const { page, filters, sortBy } = fetchData;

	const fetchList = () =>
		adjustmentsService.getAdjustmentsList({
			paidMonth,
			paidYear,
			page,
			filters,
			sortBy,
		});

	const queryResult = useQuery(
		["adjustmentsList", paidMonth, paidYear, page, filters, sortBy],
		fetchList,
		{
			retry: 0,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useAdjustmentsListQuery;
